import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles';
import { Icons, TerminalsIcon } from '@/assets';
import {
  Tooltip,
  Grid,
  Button,
  IconButton,
  FormControl,
  Select,
  OutlinedInput,
  MenuItem,
  Switch,
  withStyles,
} from '@material-ui/core';
import {
  DeleteRounded,
  CreateRounded,
  Share as ShareIcon,
} from '@material-ui/icons';
import { ReactSVG } from 'react-svg';

import clsx from 'clsx';
import {
  adminChangeScrapeSettingSchedule,
  getAdminFinanceTrackingCompanies,
  getCompanies,
  getAppointmentsSetting,
  getPerDiem,
  updatePerDiem,
  getExAppointmentsSetting,
  adminChangeScrapeSettingScheduleExAppts,
  adminChangeScrapeSettingScheduleExApptsTuggle,
} from '@/actions';
import { useNotify } from 'react-admin';
import { getEmptyReceivingSchedule, getSslList } from '@/actions';
import EditFields from './editFields';
import AddScheduler from './AddScheduler';
import { formatDateTimeToUTC } from '@/ctUtlis/formatDate';
import { fTimeDate } from '@/actions/Helper';
import { usePusher } from '../../App';
import LoadingV2 from '@/components/Loading';
import { Input } from '@/components/Input';

const CustomSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: '#0CA549',
    },
    '&$checked + $track': {
      backgroundColor: '#52d869',
    },
  },
  checked: {},
  track: {},
})(Switch);

export default ({ Terminals, selectedCompany }) => {
  const cls = styles();
  const params = useParams();
  const { channels } = usePusher();
  const [loading, setLoading] = React.useState(false);
  const [sslsList, setSslsList] = useState([]);
  const [DATADefault, setDATADefault] = React.useState([]);
  const [exAppointmentSettingList, SetExAppointmentSettingList] =
    React.useState([]);
  const [pendingPusherData, setPendingPusherData] = React.useState(null);
  const [PerDiems, setPerDiems] = useState([]);
  const [reconstructedList, setreconstructedList] = useState([]);
  const [sslsSelectOptions, setSslsSelectOptions] = useState([]);
  const [tableWidth, setTableWidth] = useState(0);
  const [spanWidth, setSpanWidth] = useState(0);
  const amirbiosRef = useRef(null);
  const tableRef = useRef(null);
  const amirbios1Ref = useRef(null);
  const amirbios2Ref = useRef(null);
  const notify = useNotify();
  const [popupMessage, setPopupMessage] = useState({
    DATA: null,
    loading: true,
    popUp: false,
  });
  useEffect(() => {
    if (channels?.publicChannel) {
      const handleExApptPusher = (data) => {
        console.log('data', data);
        // setSeenCount(data?.message?.sum);
        if (data.message) {
          setPendingPusherData(data.message);
        }
      };

      channels.publicChannel.bind(
        'ExistingAppointmentSetting',
        handleExApptPusher
      );

      return () => {
        channels.publicChannel.unbind(
          'ExistingAppointmentSetting',
          handleExApptPusher
        );
      };
    }
  }, [channels]);

  const getExAppointmentsSettingList = (selectedCompanyID, noLoading) => {
    if (noLoading) {
      setLoading(true);
    }

    getExAppointmentsSetting(selectedCompanyID)
      .then((res) => {
        // setDataTable(res.data.restrictions);
        SetExAppointmentSettingList(res.data.scrapeSettings);
        setLoading(false);
      })
      .catch((err) => {
        notify(err, 'warning');
        setLoading(false);
      });
  };

  const handleChangeScrapeSetting = (settingId, key, value, idx) => {
    adminChangeScrapeSettingScheduleExAppts(settingId, key, value)
      .then((res) => {
        if (res) {
          getExAppointmentsSettingList(selectedCompany.value, false);
        }

        notify('Successfully Updated!', 'success');
      })
      .catch((err) => {
        notify(err, 'warning');
      });
  };

  const handleChangeScrapeSettingTuggle = (
    companyId,
    terminalId,
    value,
    idx
  ) => {
    const tuggleValue = value === false ? 'ENABLE' : 'DISABLE';
    adminChangeScrapeSettingScheduleExApptsTuggle(
      companyId,
      terminalId,
      tuggleValue
    )
      .then((res) => {
        if (res) {
          getExAppointmentsSettingList(selectedCompany.value, false);
        }
        notify('Successfully Updated!', 'success');
      })
      .catch((err) => {
        notify(err, 'warning');
      });
  };

  useEffect(() => {
    if (sslsList.length > 0) {
      const options = sslsList.map((ssl, index) => ({
        label: ssl.name_full,
        slug: ssl.name,
        id: ssl.id,
        value: index + 1,
      }));

      // Set portSelectOptions state
      setSslsSelectOptions(options);
    }
  }, [sslsList]);

  useEffect(() => {
    if (
      selectedCompany !== null &&
      selectedCompany !== '0' &&
      selectedCompany !== undefined
    ) {
      getExAppointmentsSettingList(selectedCompany.value, true);
    }
  }, [selectedCompany]);

  // useEffect(() => {
  //   getCompanies();
  // }, [exAppointmentSettingList]);

  // Apply pending pusher data when exAppointmentSettingList is loaded
  useEffect(() => {
    if (
      pendingPusherData &&
      Array.isArray(exAppointmentSettingList) &&
      exAppointmentSettingList.length > 0
    ) {
      const updatedList = exAppointmentSettingList.map((item) => {
        if (item.id === pendingPusherData.id) {
          return pendingPusherData; // Replace with pusher data
        }
        return item; // Keep original item
      });

      SetExAppointmentSettingList(updatedList);
      setPendingPusherData(null); // Clear pending data
    }
  }, [pendingPusherData, exAppointmentSettingList]);

  useEffect(() => {
    const reconstructedJson = {};

    for (const perDiem of PerDiems) {
      const shippingLineAlias = perDiem.shipping_line.alias;

      const specificationSizeKey = perDiem.specification.size
        ? `${perDiem.specification.size} `
        : '';
      const specificationNameKey = perDiem.specification.name
        ? `${perDiem.specification.name} `
        : '';
      const specificationModelKey = perDiem.specification.model
        ? `${perDiem.specification.model}`
        : '';
      const specificationKey = `${
        specificationSizeKey + specificationNameKey + specificationModelKey
      }`;
      // const specificationKey = `${perDiem.specification.size} ${perDiem.specification.name} ${perDiem.specification.model}`;
      const phaseKey = `phase${perDiem.phase}`;
      const typeKey = perDiem.type === 'IB' ? 'IB' : 'OB';
      if (!reconstructedJson[shippingLineAlias]) {
        reconstructedJson[shippingLineAlias] = {};
      }

      if (!reconstructedJson[shippingLineAlias][specificationKey]) {
        reconstructedJson[shippingLineAlias][specificationKey] = {};
      }

      if (!reconstructedJson[shippingLineAlias][specificationKey][typeKey]) {
        reconstructedJson[shippingLineAlias][specificationKey][typeKey] = {};
      }

      if (
        !reconstructedJson[shippingLineAlias][specificationKey][typeKey][
          phaseKey
        ]
      ) {
        reconstructedJson[shippingLineAlias][specificationKey][typeKey][
          phaseKey
        ] = [];
      }

      // Add the perDiem object to the respective group
      reconstructedJson[shippingLineAlias][specificationKey][typeKey][
        phaseKey
      ].push({
        id: perDiem.id,
        phase: perDiem.phase,
        type: perDiem.type,
        with_chassis: perDiem.with_chassis,
        start_day: perDiem.start_day,
        end_day: perDiem.end_day,
        per_diem_amount: perDiem.per_diem_amount,
        saturday: perDiem.saturday,
        sunday: perDiem.sunday,
        saturday_lfd: perDiem.saturday_lfd,
        sunday_lfd: perDiem.sunday_lfd,
        pickup_day_included: perDiem.pickup_day_included,
        return_day_included: perDiem.return_day_included,
        holidays_included: perDiem.holidays_included,
        status: perDiem.status,
        created_at: perDiem.created_at,
        updated_at: perDiem.updated_at,
        shipping_line: perDiem.shipping_line,
        specification: perDiem.specification,
      });
    }

    setreconstructedList(reconstructedJson);
  }, [PerDiems]);

  useEffect(() => {
    const handleScroll = () => {
      if (amirbiosRef.current && amirbios1Ref.current) {
        const amirbiosTop = amirbiosRef.current.getBoundingClientRect().top;

        if (amirbiosTop <= 42) {
          amirbios2Ref.current.classList.add(cls.fix);
          tableRef.current.classList.add(cls.tableTopMargin);
        } else {
          amirbios2Ref.current.classList.remove(cls.fix);
          tableRef.current.classList.remove(cls.tableTopMargin);
        }
      }
      syncScroll('amirbios');
    };
    const updateWidth = () => {
      if (tableRef.current && amirbios1Ref.current) {
        const tableCurrentWidth =
          tableRef.current.getBoundingClientRect().width;
        setTableWidth(tableCurrentWidth);
      }
    };

    const updateHeadWidth = () => {
      if (amirbiosRef.current && amirbios2Ref.current) {
        const tableeCurrentWidth =
          amirbiosRef.current.getBoundingClientRect().width;
        setSpanWidth(tableeCurrentWidth);
      }
    };

    const syncScroll = (source) => {
      if (amirbiosRef.current && amirbios2Ref.current) {
        if (source === 'amirbios') {
          amirbios2Ref.current.scrollLeft = amirbiosRef.current.scrollLeft;
        } else if (source === 'amirbios2') {
          amirbiosRef.current.scrollLeft = amirbios2Ref.current.scrollLeft;
        }
      }
    };

    // Initial width setting
    updateWidth();
    updateHeadWidth();

    window.updateWidth = updateWidth;
    window.updateHeadWidth = updateHeadWidth;
    window.syncScroll = syncScroll;

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('scroll', updateWidth);
    window.addEventListener('resize', updateWidth);
    window.addEventListener('scroll', updateHeadWidth);
    window.addEventListener('resize', updateHeadWidth);
    if (amirbiosRef.current) {
      amirbiosRef.current.addEventListener('scroll', () =>
        syncScroll('amirbios')
      );
    }
    if (amirbios2Ref.current) {
      amirbios2Ref.current.addEventListener('scroll', () =>
        syncScroll('amirbios2')
      );
    }

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', updateWidth);
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('scroll', updateHeadWidth);
      window.removeEventListener('resize', updateHeadWidth);
      if (amirbiosRef.current) {
        amirbiosRef.current.removeEventListener('scroll', () =>
          syncScroll('amirbios')
        );
      }
      if (amirbios2Ref.current) {
        amirbios2Ref.current.removeEventListener('scroll', () =>
          syncScroll('amirbios2')
        );
      }
    };
  }, [tableWidth, spanWidth, reconstructedList]);

  useEffect(() => {
    if (amirbios2Ref.current) {
      amirbios2Ref.current.style.width = `${spanWidth - 4}px`;
    }
  }, [spanWidth]);

  useEffect(() => {
    if (amirbios1Ref.current) {
      amirbios1Ref.current.style.width = `${tableWidth - 4}px`;
    }
  }, [tableWidth]);

  if (amirbios2Ref.current) {
    amirbios2Ref.current.style.width = `${spanWidth - 4}px`;
  }

  if (amirbios1Ref.current) {
    amirbios1Ref.current.style.width = `${tableWidth - 4}px`;
  }

  return (
    <>
      {popupMessage.popUp && (
        <AddScheduler
          DATA={popupMessage.DATA}
          settingId={popupMessage.settingId}
          Label={popupMessage.Label}
          sslsList={sslsList}
          vessel_id={popupMessage.vessel_id}
          column_name={popupMessage.column_name}
          column_value={popupMessage.DATA}
          Close={() =>
            setPopupMessage((prev) => {
              return {
                ...prev,
                popUp: false,
              };
            })
          }
        />
      )}

      <div ref={amirbiosRef} id="amirbios" className={cls.listContainer}>
        {loading ? (
          <div className="mt-16">
            <LoadingV2 />
          </div>
        ) : selectedCompany === null ||
          selectedCompany === '0' ||
          selectedCompany === undefined ? (
          'Please Select a Company'
        ) : (
          <table ref={tableRef} id="table" className={cls.list}>
            <span ref={amirbios2Ref} id="amirbios1">
              <thead ref={amirbios1Ref} id="amirbios2" className={cls.thead}>
                <span style={{ flex: 1 }} className={cls.shifttd}>
                  <th style={{ flex: 1 }}>Terminal</th>
                </span>
                <span style={{ flex: 1 }} className={cls.shifttd}>
                  <th style={{ flex: 1 }}>Integration</th>
                </span>
                <span style={{ flex: 1.2 }} className={cls.shifttd}>
                  <th style={{ flex: 1 }}>Scraping Frequency</th>
                </span>
                <span style={{ flex: 1 }} className={cls.shifttd}>
                  <th style={{ flex: 1 }}>Last Scrape</th>
                </span>
                <span style={{ flex: 1 }} className={cls.shifttd}>
                  <th style={{ flex: 1 }}>Next Scrape</th>
                </span>
                <span style={{ flex: 1 }} className={cls.shifttd}>
                  <th style={{ flex: 1 }}>Status</th>
                </span>
                <span style={{ flex: 2 }} className={cls.shifttd}>
                  <th style={{ flex: 1 }}>Action</th>
                </span>
              </thead>
            </span>
            <tbody className={cls.tbody}>
              {Array.isArray(exAppointmentSettingList) &&
              exAppointmentSettingList.length > 0
                ? exAppointmentSettingList.map((item, idx) => (
                    <tr className={cls.tableRow} key={idx}>
                      <td style={{ flex: 1 }} className={cls.shifttd}>
                        <span>
                          <a
                            className={cls.terminalLink}
                            target="_blank"
                            href={item.terminal?.links.gate_schedule}>
                            <img
                              width={80}
                              src={
                                item.scrapeable_id == 'APM'
                                  ? TerminalsIcon.APM
                                  : item.scrapeable_id == 'FMS'
                                  ? TerminalsIcon.FMS
                                  : item.scrapeable_id == 'EVERPORT'
                                  ? TerminalsIcon.EVERPORT
                                  : item.scrapeable_id == 'LACT'
                                  ? TerminalsIcon.LACT
                                  : item.scrapeable_id == 'PCT'
                                  ? TerminalsIcon.PCT
                                  : item.scrapeable_id == 'PST'
                                  ? TerminalsIcon.PST
                                  : item.scrapeable_id == 'TRAPAC'
                                  ? TerminalsIcon.TRAPAC
                                  : item.scrapeable_id == 'WBCT'
                                  ? TerminalsIcon.WBCT
                                  : item.scrapeable_id == 'WCC'
                                  ? TerminalsIcon.WCC
                                  : item.scrapeable_id == 'YTI'
                                  ? TerminalsIcon.YTI
                                  : item.scrapeable_id == 'TTI'
                                  ? TerminalsIcon.TTI
                                  : item.scrapeable_id == 'ITS'
                                  ? TerminalsIcon.ITS
                                  : item.scrapeable_id == 'LBCT'
                                  ? TerminalsIcon.LBCT
                                  : item.scrapeable_id == 'MATSON'
                                  ? TerminalsIcon.MATSON
                                  : item.scrapeable_id == 'SSA MARINE'
                                  ? TerminalsIcon.SSA
                                  : item.scrapeable_id == 'SSA STL'
                                  ? TerminalsIcon.STL
                                  : item.scrapeable_id == 'PTS'
                                  ? TerminalsIcon.PTS
                                  : ''
                              }
                            />
                            {item.scrapeable_id}
                          </a>
                        </span>
                      </td>
                      <td style={{ flex: 1 }} className={cls.shifttd}>
                        <FormControl>
                          <Select
                            displayEmpty
                            disableUnderline={true}
                            defaultValue={item.scrape_type}
                            className={cls.selectBox}
                            onChange={(e) =>
                              handleChangeScrapeSetting(
                                item.id,
                                'scrape_type',
                                item.scrape_type === 'SCRAPE'
                                  ? 'API'
                                  : item.scrape_type === 'API'
                                  ? 'SCRAPE'
                                  : '',
                                idx
                              )
                            }
                            inputProps={{ 'aria-label': 'Without label' }}>
                            <MenuItem key={0} value={'SCRAPE'}>
                              SCRAPE
                            </MenuItem>
                            <MenuItem key={1} value={'API'}>
                              API
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </td>
                      <td style={{ flex: 1.2 }} className={cls.shifttd}>
                        <div className="flex items-center gap-2 px-2">
                          <Input
                            style={{
                              width: '100%',
                              height: '32px',
                            }}
                            defaultValue={item.scrape_frequency}
                            onChange={(e) =>
                              handleChangeScrapeSetting(
                                item.id,
                                'scrape_frequency',
                                e.target.value,
                                idx
                              )
                            }
                          />
                          <span>Min</span>
                        </div>
                      </td>
                      <td style={{ flex: 1 }} className={cls.shifttd}>
                        {fTimeDate(item.last_scrape)}
                      </td>
                      <td style={{ flex: 1 }} className={cls.shifttd}>
                        {fTimeDate(item.next_scrape)}
                      </td>
                      <td style={{ flex: 1 }} className={cls.shifttd}>
                        <Tooltip
                          arrow
                          title={item?.failed_message}
                          placement="top">
                          <span className={cls.fStatus}>
                            {item?.failed_message}
                          </span>
                        </Tooltip>
                      </td>
                      <td style={{ flex: 2 }} className={cls.shifttd}>
                        {item.status === 'DISABLED' ? (
                          <Tooltip arrow title="Disabled" placement="top">
                            <IconButton
                              aria-label="Disable"
                              onClick={() => {
                                handleChangeScrapeSetting(
                                  item.id,
                                  'status',
                                  'ENABLED',
                                  idx
                                );
                              }}>
                              <ReactSVG
                                src={Icons.close}
                                className={cls.icon}
                              />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip arrow title="Enabled" placement="top">
                            <IconButton
                              aria-label="enable"
                              onClick={() => {
                                handleChangeScrapeSetting(
                                  item.id,
                                  'status',
                                  'DISABLED',
                                  idx
                                );
                              }}>
                              <ReactSVG
                                src={Icons.tickICon}
                                className={cls.icon}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip arrow title="Refresh" placement="top">
                          <IconButton
                            aria-label="refresh"
                            onClick={() =>
                              handleChangeScrapeSetting(
                                item.id,
                                'refresh_scrape',
                                1,
                                idx
                              )
                            }>
                            <ReactSVG
                              src={Icons.refreshIcon}
                              className={cls.icon}
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          arrow
                          title={
                            item.failed_toggle === true ? 'Enabled' : 'Disabled'
                          }
                          placement="top">
                          <CustomSwitch
                            checked={item.failed_toggle === true}
                            onChange={() =>
                              handleChangeScrapeSettingTuggle(
                                item.user_id,
                                item.scrapeable_id,
                                item.failed_toggle,
                                idx
                              )
                            }
                            name="custom-toggle"
                            size="small"
                          />
                        </Tooltip>
                      </td>
                    </tr>
                  ))
                : ''}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};
